// Runtime state, filled in at bootstrap from the URL and the client record. Not deployment
// config: per-environment values live in src/environments/.
const runtimeConfig = {
    clientId: 0,
    clientCode: "",
    turnstileSiteKey: ""
};
